/**
 * @file backup-draft.ts
 * @description Черновик формы настроек бэкапа (phase19.26): значение формы,
 * заполнение из конфига, проверка и тело PATCH.
 *
 * Папка и хранилище копий — в «Где хранить копии» (`backup-destination.ts`).
 *
 * Числа и e-mail в форме — строками, как ввёл человек; в запрос уходят
 * числом и `null` («не слать письма»).
 */

import {
  alertEmailError,
  type BackupConfigDto,
  type UpdateBackupConfigPayload,
} from "../../../lib/api-backups";

export interface BackupDraft {
  isEnabled: boolean;
  cronExpression: string;
  databaseIncluded: boolean;
  bucketsIncluded: string[];
  retentionDays: string;
  alertEmail: string;
}

export function draftFromConfig(cfg: BackupConfigDto): BackupDraft {
  return {
    isEnabled: cfg.isEnabled,
    cronExpression: cfg.cronExpression,
    databaseIncluded: cfg.databaseIncluded,
    bucketsIncluded: cfg.bucketsIncluded,
    retentionDays: String(cfg.retentionDays),
    alertEmail: cfg.alertEmail ?? "",
  };
}

/** Первая ошибка формы человеческим текстом; null — можно сохранять. */
export function draftError(d: BackupDraft): string | null {
  const retention = Number(d.retentionDays);
  if (!Number.isInteger(retention) || retention < 1 || retention > 3650) {
    return "Срок хранения — целое число дней от 1 до 3650.";
  }
  if (d.bucketsIncluded.length === 0) {
    return "Выберите хотя бы одно хранилище файлов.";
  }
  const email = alertEmailError(d.alertEmail);
  if (email) return `E-mail для уведомлений: ${email}`;
  return null;
}

export function draftToPayload(d: BackupDraft): UpdateBackupConfigPayload {
  return {
    isEnabled: d.isEnabled,
    cronExpression: d.cronExpression.trim(),
    databaseIncluded: d.databaseIncluded,
    bucketsIncluded: d.bucketsIncluded,
    retentionDays: Number(d.retentionDays),
    alertEmail: d.alertEmail.trim() || null,
  };
}
